import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';

export interface Args {
	onClose: () => void;
}

export default class AppNotificationsStatusComponent extends Component<Args> {
	@service('account') declare accountService: Service.Account;
	@service('app-notifications') declare appNotificationsService: Service.AppNotifications;

	get systemStatus() {
		return this.appNotificationsService.systemStatus;
	}

	get showReadMore() {
		return !this.accountService.hideDataboxNotWhiteLabeledContentForNonAdmins;
	}
	<template>
		<div class="notification-container status-notification">
			<div class="container">
				<a role="button" class="close" {{on "click" @onClose}}>
					<CommonUiIconComponent @name="Close" @size="sm" />
				</a>

				<p>
					<CommonUiIconComponent @name="InfoFill" @size="sm" />
					{{this.systemStatus.name}}
				</p>
				{{#if this.showReadMore}}
					<a href={{this.systemStatus.shortLink}} target="_blank">Read more</a>
				{{/if}}
			</div>
		</div>
	</template>
}
